/**
 * 社員個別年間給料精算 - 列表页面
 * 筛选：社員形式、社員名（与社員検索画面同様、初期何も表示しない）
 * 列表：番号(1から)、年度番号(直近3年度/2022年1月～)、お客様、単価、給料、賞与、社会保険料、粗利益見込、年間履歴見込み、他のコスト集計
 * 給料が変わった行は線と色が変化
 */
import React, { Component } from "react";
import {
  Row,
  Col,
  InputGroup,
  Button,
  Form,
} from "react-bootstrap";
import { Table, Modal, Input } from "antd";
import Autocomplete from "@material-ui/lab/Autocomplete";
import axios from "axios";
import * as publicUtils from "./utils/publicUtils.js";
import ErrorsMessageToast from "./errorsMessageToast";
import store from "./redux/store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import "../asserts/css/style.css";

axios.defaults.withCredentials = true;

/** 円：四舍五入到整数并加千分位分隔。 */
function formatYenNumber(valueInYen) {
  var v = Math.round(Number(valueInYen) || 0);
  return publicUtils.addComma(v);
}

// 按 reflectYearAndMonth 划分区间，每区间一色，区分明显
var INTERVAL_BG_COLORS = [
  "rgba(200, 220, 255, 0.78)",
  "rgba(200, 238, 215, 0.78)",
  "rgba(255, 228, 200, 0.78)",
  "rgba(230, 210, 255, 0.78)",
  "rgba(255, 235, 235, 0.78)",
  "rgba(220, 245, 255, 0.78)",
  "rgba(255, 248, 220, 0.78)",
  "rgba(235, 255, 235, 0.78)",
];

class EmployeeAnnualPayrollSearch extends Component {
  constructor(props) {
    super(props);
    this.state = this.initialState;
  }

  initialState = {
    // 与 社員.BP -> 年間給料精算（payroll.js）一致：使用「社員区分」dropDown[4]，并排除 code==1
    employeeFormCodes: (store.getState().dropDown[4] || []).filter((d) => d.code != 1),
    employeeInfo: (store.getState().dropDown[9] || []).slice(1),
    employeeInfoAll: (store.getState().dropDown[9] || []).slice(1),
    employeeFormCode: "",
    employeeName: "",
    employeeNo: "",
    selectedEmployeeFormCode: "",
    list: [],
    otherList: [],
    editingCell: null,
    editingValue: "",
    serverIP: store.getState().dropDown[store.getState().dropDown.length - 1],
    errorsMessageShow: false,
    errorsMessageValue: "",
  };

  valueChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({ [name]: value }, () => {
      if (name === "employeeFormCode") this.filterEmployeeInfoByForm();
    });
  };

  filterEmployeeInfoByForm = () => {
    const code = this.state.employeeFormCode;
    const all = this.state.employeeInfoAll || [];
    let filtered = all;
    // 与 payroll.js 的 employeeStatusChange 逻辑保持一致
    if (code === "0") {
      filtered = all.filter(
        (e) =>
          e.code.substring(0, 2) !== "BP" &&
          e.code.substring(0, 2) !== "SP" &&
          e.code.substring(0, 2) !== "SC"
      );
    } else if (code === "2") {
      filtered = all.filter((e) => e.code.substring(0, 2) === "SP");
    } else {
      filtered = all;
    }
    this.setState({ employeeInfo: filtered, employeeName: "", employeeNo: "", selectedEmployeeFormCode: "" });
  };

  getEmployeeName = (event, values) => {
    if (values == null) {
      this.setState({ employeeName: "", employeeNo: "", selectedEmployeeFormCode: "" });
      return;
    }
    var formCode = values.employeeFormCode || values.employeeForm || "";
    if (!formCode && values.code) {
      var c = String(values.code);
      if (c.substring(0, 2) === "BP") formCode = "1";
      else if (c.substring(0, 2) === "SP") formCode = "2";
      else if (c.substring(0, 2) === "SC") formCode = "3";
      else formCode = this.state.employeeFormCode || "0";
    }
    if (!formCode) formCode = this.state.employeeFormCode || "";
    this.setState({
      employeeName: values.text || values.name || "",
      employeeNo: values.code || "",
      selectedEmployeeFormCode: formCode,
    });
  };

  search = () => {
    if (!this.state.employeeNo) {
      this.setState({
        errorsMessageShow: true,
        errorsMessageValue: "社員名を選択してください",
      });
      setTimeout(() => this.setState({ errorsMessageShow: false }), 3000);
      return;
    }
    const param = {
      employeeFormCode: this.state.employeeFormCode || undefined,
      employeeNo: this.state.employeeNo,
    };
    const baseUrl = this.state.serverIP || "/api-backend/";
    axios
      .post(baseUrl + "employeeAnnualPayroll/search", param)
      .then((res) => {
        // 后端可能直接返回数组，此时 res.data 即为数组，无 errorsMessage
        const raw = Array.isArray(res.data)
          ? res.data
          : res.data.list ?? res.data.data ?? res.data.result ?? [];
        if (!Array.isArray(res.data) && res.data.errorsMessage) {
          this.setState({
            errorsMessageShow: true,
            errorsMessageValue: res.data.errorsMessage,
            list: [],
          });
          return;
        }
        var rows = raw || [];
        var nextColorIndex = 0;
        var list = rows.map(function (row, idx) {
          var prev = idx > 0 ? rows[idx - 1] : null;
          var salaryChanged = prev != null && String(prev.salary) !== String(row.salary);
          var unitPriceChanged = prev != null && String(prev.unitPrice) !== String(row.unitPrice);
          var up = Number(row.unitPrice) || 0;
          var sal = Number(row.salary) || 0;
          var ins = Number(row.insuranceFeeAmount) || 0;
          var roughProfitEst = up - sal - ins;
          var isFirstOfInterval = idx === 0 || salaryChanged;
          var intervalStart = isFirstOfInterval && row.yearAndMonth != null ? String(row.yearAndMonth) : null;
          var intervalColorIndex = isFirstOfInterval ? (nextColorIndex++ % INTERVAL_BG_COLORS.length) : null;
          return {
            ...row,
            rowNo: idx + 1,
            intervalStart: intervalStart,
            intervalColorIndex: intervalColorIndex,
            _firstOfInterval: isFirstOfInterval,
            salaryChanged: salaryChanged,
            unitPriceChanged: unitPriceChanged,
            roughProfitEst: roughProfitEst,
          };
        });
        var currentStart = null;
        var currentColorIndex = null;
        for (var fi = 0; fi < list.length; fi++) {
          if (list[fi]._firstOfInterval && list[fi].intervalStart != null && list[fi].intervalStart !== "") {
            currentStart = list[fi].intervalStart;
            currentColorIndex = list[fi].intervalColorIndex;
          }
          if (currentStart == null && list[fi].yearAndMonth != null && String(list[fi].yearAndMonth) !== "") {
            currentStart = String(list[fi].yearAndMonth);
            currentColorIndex = list[fi].intervalColorIndex;
            if (currentColorIndex == null) currentColorIndex = (nextColorIndex - 1 + INTERVAL_BG_COLORS.length) % INTERVAL_BG_COLORS.length;
          }
          if (currentStart != null) {
            list[fi].intervalStart = currentStart;
            list[fi].intervalColorIndex = currentColorIndex;
          }
          delete list[fi]._firstOfInterval;
        }
        for (var bi = 0; bi < list.length; bi++) {
          if (list[bi].intervalStart == null && bi > 0) {
            list[bi].intervalStart = list[bi - 1].intervalStart;
            list[bi].intervalColorIndex = list[bi - 1].intervalColorIndex;
          }
        }
        for (var bj = list.length - 1; bj >= 0; bj--) {
          if (list[bj].intervalStart == null && bj < list.length - 1) {
            list[bj].intervalStart = list[bj + 1].intervalStart;
            list[bj].intervalColorIndex = list[bj + 1].intervalColorIndex;
          }
        }
        var intervalCount = {};
        for (var ci = 0; ci < list.length; ci++) {
          var st = list[ci].intervalStart;
          if (st) intervalCount[st] = (intervalCount[st] || 0) + 1;
        }
        var nextIntervalIndex = 1;
        for (var si = 0; si < list.length; si++) {
          var prevStart = si > 0 ? list[si - 1].intervalStart : null;
          var isFirst = list[si].intervalStart !== prevStart;
          list[si].otherIntervalRowSpan = isFirst && list[si].intervalStart ? (intervalCount[list[si].intervalStart] || 1) : 0;
          if (isFirst && list[si].intervalStart) list[si].intervalIndex = nextIntervalIndex++;
        }
        for (var bi = 0; bi < list.length; bi++) {
          if (list[bi].intervalIndex == null && bi > 0) list[bi].intervalIndex = list[bi - 1].intervalIndex;
        }
        for (var bj = list.length - 1; bj >= 0; bj--) {
          if (list[bj].intervalIndex == null && bj < list.length - 1) list[bj].intervalIndex = list[bj + 1].intervalIndex;
        }
        this.setState({ list: list, errorsMessageShow: false });
        var self = this;
        axios.post(baseUrl + "employeeAnnualPayroll/otherSearch", param).then(function (res) {
          var otherRaw = Array.isArray(res.data) ? res.data : (res.data && (res.data.list || res.data.data || res.data.result)) || [];
          var otherByYearMonth = {};
          for (var k = 0; k < otherRaw.length; k++) {
            var o = otherRaw[k];
            var ym = o.salaryYearMonth != null ? String(o.salaryYearMonth) : (o.salaryYear != null ? String(o.salaryYear) : "");
            if (ym) otherByYearMonth[ym] = o;
          }
          var intervalRows = {};
          for (var r = 0; r < list.length; r++) {
            var start = list[r].intervalStart;
            if (!start) continue;
            if (!intervalRows[start]) intervalRows[start] = { salary: [], bonus: [], insurance: [] };
            intervalRows[start].salary.push(Number(list[r].salary) || 0);
            intervalRows[start].bonus.push(Number(list[r].bonusAmount) || 0);
            intervalRows[start].insurance.push(Number(list[r].insuranceFeeAmount) || 0);
          }
          var sum = function (a) { var s = 0; for (var i = 0; i < a.length; i++) s += a[i]; return s; };
          var intervalAvg = {};
          for (var ik in intervalRows) {
            var arr = intervalRows[ik];
            intervalAvg[ik] = {
              avgSalary: arr.salary.length ? sum(arr.salary) / arr.salary.length : 0,
              avgBonus: arr.bonus.length ? sum(arr.bonus) / arr.bonus.length : 0,
              avgInsurance: arr.insurance.length ? sum(arr.insurance) / arr.insurance.length : 0,
            };
          }
          var intervalCountMerge = {};
          for (var ri = 0; ri < list.length; ri++) {
            var st = list[ri].intervalStart;
            if (st) intervalCountMerge[st] = (intervalCountMerge[st] || 0) + 1;
          }
          var mergedList = list.map(function (row, idx) {
            var intervalStart = row.intervalStart;
            var prevStart = idx > 0 ? list[idx - 1].intervalStart : null;
            var isFirstOfInterval = intervalStart && intervalStart !== prevStart;
            var other = intervalStart ? (otherByYearMonth[intervalStart] || otherByYearMonth[intervalStart.substring(0, 4)]) : null;
            var avg = intervalStart ? (intervalAvg[intervalStart] || { avgSalary: 0, avgBonus: 0, avgInsurance: 0 }) : { avgSalary: 0, avgBonus: 0, avgInsurance: 0 };
            var salVal = avg.avgSalary;
            var bonusVal = avg.avgBonus;
            var transportVal = (other && other.transportAmount != null) ? Number(other.transportAmount) : 0;
            var socialVal = avg.avgInsurance;
            var othersVal = (other && (other.othersPayOffAmount != null || other.othersPayoffAmount != null)) ? (Number(other.othersPayOffAmount || other.othersPayoffAmount) || 0) : 0;
            var totalVal = (salVal || 0) + (bonusVal || 0) + (transportVal || 0) + (socialVal || 0) + (othersVal || 0);
            var otherSummary = {
              salary: formatYenNumber(salVal || 0) + "円",
              bonusPayOffAmount: formatYenNumber(bonusVal || 0) + "円",
              transportAmount: formatYenNumber(transportVal || 0) + "円",
              socialInsurancePayOffAmount: formatYenNumber(socialVal || 0) + "円",
              othersPayOffAmount: formatYenNumber(othersVal || 0) + "円",
              total: formatYenNumber(totalVal) + "円",
              salaryVal: salVal || 0,
              bonusVal: bonusVal || 0,
              transportAmountVal: transportVal || 0,
              socialVal: socialVal || 0,
              othersPayOffAmountVal: othersVal || 0,
              totalVal: totalVal,
            };
            var otherIntervalRowSpan = isFirstOfInterval ? (intervalCountMerge[intervalStart] || 1) : 0;
            return { ...row, otherSummary: otherSummary, otherIntervalRowSpan: otherIntervalRowSpan };
          });
          self.setState({ list: mergedList, otherList: otherRaw });
        }).catch(function () {});
      })
      .catch(() => {
        this.setState({
          errorsMessageShow: true,
          errorsMessageValue: "エラーが発生しました。画面をリフレッシュしてください。",
          list: [],
        });
      });
  };

  reset = () => {
    this.setState({
      employeeFormCode: "",
      employeeName: "",
      employeeNo: "",
      selectedEmployeeFormCode: "",
      list: [],
      otherList: [],
      editingCell: null,
      editingValue: "",
      employeeInfo: this.state.employeeInfoAll || [],
    });
  };

  formatAmount = (c) =>
    c != null && c !== "" ? publicUtils.addComma(c) : (c ?? "");

  formatYenAbsInt = (c) => {
    if (c == null || c === "") return "";
    const n = Number(c);
    if (Number.isNaN(n)) return c;
    return publicUtils.addComma(Math.abs(Math.round(n)));
  };

  startEdit = (record, field) => {
    if (!record || !record.otherSummary) return;
    var salaryYearMonth = record.intervalStart || "";
    var val = field === "transportAmount" ? record.otherSummary.transportAmountVal : record.otherSummary.othersPayOffAmountVal;
    this.setState({ editingCell: { salaryYearMonth, field }, editingValue: String(Math.round(Number(val) || 0)) });
  };

  trySaveEdit = (salaryYearMonth, field) => {
    var { editingCell, editingValue, list } = this.state;
    if (!editingCell || editingCell.salaryYearMonth !== salaryYearMonth || editingCell.field !== field) return;
    var row = list.find(function (r) {
      return r.intervalStart === salaryYearMonth && r.otherSummary;
    });
    if (!row || !row.otherSummary) {
      this.setState({ editingCell: null, editingValue: "" });
      return;
    }
    var rawVal = field === "transportAmount" ? row.otherSummary.transportAmountVal : row.otherSummary.othersPayOffAmountVal;
    var newYen = parseFloat(editingValue);
    if (Number.isNaN(newYen)) newYen = 0;
    var newVal = Math.round(newYen);
    if (newVal === (Number(rawVal) || 0)) {
      this.setState({ editingCell: null, editingValue: "" });
      return;
    }
    var self = this;
    Modal.confirm({
      title: "確認",
      content: "内容が変更されています。保存しますか？",
      okText: "確認",
      cancelText: "取消",
      onOk: function () {
        self.submitEmployeeAnnualSalary(salaryYearMonth, row.otherSummary, field, newVal);
      },
      onCancel: function () {
        self.setState({ editingCell: null, editingValue: "" });
      },
    });
  };

  submitEmployeeAnnualSalary = (salaryYearMonth, summary, changedField, newVal) => {
    var employeeNo = this.state.employeeNo;
    var employeeFormCode = this.state.selectedEmployeeFormCode || "";
    var salaryVal = summary.salaryVal || 0;
    var bonusVal = summary.bonusVal || 0;
    var transportAmountVal = changedField === "transportAmount" ? newVal : (summary.transportAmountVal || 0);
    var socialVal = summary.socialVal || 0;
    var othersPayOffAmountVal = changedField === "othersPayOffAmount" ? newVal : (summary.othersPayOffAmountVal || 0);
    var totalPayOffAmount = salaryVal + bonusVal + transportAmountVal + socialVal + othersPayOffAmountVal;
    var baseUrl = this.state.serverIP || "/api-backend/";
    var param = {
      employeeNo: employeeNo,
      employeeFormCode: employeeFormCode,
      salaryYearMonth: salaryYearMonth,
      salary: salaryVal,
      bonusPayOffAmount: bonusVal,
      transportAmount: transportAmountVal,
      socialInsurancePayOffAmount: socialVal,
      othersPayOffAmount: othersPayOffAmountVal,
      totalPayOffAmount: totalPayOffAmount,
    };
    var self = this;
    axios.post(baseUrl + "employeeAnnualPayroll/updateEmployeeAnnualSalary", param).then(function () {
      self.setState({ editingCell: null, editingValue: "" });
      self.updateListAfterSalaryEdit(salaryYearMonth, changedField, newVal);
    }).catch(function () {
      self.setState({ errorsMessageShow: true, errorsMessageValue: "保存に失敗しました。", editingCell: null, editingValue: "" });
      setTimeout(function () { self.setState({ errorsMessageShow: false }); }, 3000);
    });
  };

  updateListAfterSalaryEdit = (salaryYearMonth, field, newVal) => {
    var list = this.state.list.slice();
    var newYenStr = formatYenNumber(newVal) + "円";
    for (var i = 0; i < list.length; i++) {
      if (!list[i].otherSummary) continue;
      if (list[i].intervalStart !== salaryYearMonth) continue;
      var s = list[i].otherSummary;
      if (field === "transportAmount") {
        s.transportAmount = newYenStr;
        s.transportAmountVal = newVal;
      } else {
        s.othersPayOffAmount = newYenStr;
        s.othersPayOffAmountVal = newVal;
      }
      s.totalVal = (s.salaryVal || 0) + (s.bonusVal || 0) + (s.transportAmountVal || 0) + (s.socialVal || 0) + (s.othersPayOffAmountVal || 0);
      s.total = formatYenNumber(s.totalVal) + "円";
    }
    this.setState({ list: list });
  };

  /** 他のコスト集計：6行居中（給料・賞与・交通費・社会保険料・その他・約），交通費・その他可编辑 */
  formatOtherCostSummary = (cell, record) => {
    if (!record || !record.otherSummary) return "";
    var s = record.otherSummary;
    var salaryYearMonth = record.intervalStart || "";
    var editing = this.state.editingCell;
    var isEditTransport = editing && editing.salaryYearMonth === salaryYearMonth && editing.field === "transportAmount";
    var isEditOthers = editing && editing.salaryYearMonth === salaryYearMonth && editing.field === "othersPayOffAmount";
    var lineStyle = { marginBottom: 2 };
    var editableStyle = { cursor: "pointer", padding: "2px 4px", borderRadius: 2 };
    return (
      <div style={{ textAlign: "center", verticalAlign: "middle", lineHeight: 1.6 }}>
        <div style={lineStyle}>給料 {s.salary || "0円"}</div>
        <div style={lineStyle}>賞与 {s.bonusPayOffAmount || "0円"}</div>
        <div style={lineStyle}>
          {isEditTransport ? (
            <span>
              <Input
                size="small"
                value={this.state.editingValue}
                onChange={(e) => this.setState({ editingValue: e.target.value })}
              onBlur={() => this.trySaveEdit(salaryYearMonth, "transportAmount")}
              onKeyDown={(e) => { if (e.key === "Enter") this.trySaveEdit(salaryYearMonth, "transportAmount"); }}
                style={{ width: 72, textAlign: "center" }}
                autoFocus
              />
              {" "}円
            </span>
          ) : (
            <span
              style={editableStyle}
              className="other-cost-editable"
              onMouseEnter={(e) => { e.currentTarget.style.background = "#f5f5f5"; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = ""; }}
              onClick={() => this.startEdit(record, "transportAmount")}
            >
              交通費 {s.transportAmount || "0円"}
            </span>
          )}
        </div>
        <div style={lineStyle}>社会保険料 {s.socialInsurancePayOffAmount || "0円"}</div>
        <div style={lineStyle}>
          {isEditOthers ? (
            <span>
              <Input
                size="small"
                value={this.state.editingValue}
                onChange={(e) => this.setState({ editingValue: e.target.value })}
                onBlur={() => this.trySaveEdit(salaryYearMonth, "othersPayOffAmount")}
                onKeyDown={(e) => { if (e.key === "Enter") this.trySaveEdit(salaryYearMonth, "othersPayOffAmount"); }}
                style={{ width: 72, textAlign: "center" }}
                autoFocus
              />
              {" "}円
            </span>
          ) : (
            <span
              style={editableStyle}
              className="other-cost-editable"
              onMouseEnter={(e) => { e.currentTarget.style.background = "#f5f5f5"; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = ""; }}
              onClick={() => this.startEdit(record, "othersPayOffAmount")}
            >
              その他 {s.othersPayOffAmount || "0円"}
            </span>
          )}
        </div>
        <div style={{ borderTop: "1px solid #ccc", marginTop: 2, paddingTop: 2 }}>約 {s.total || "0円"}</div>
      </div>
    );
  };

  /** 単価・給料用：数值(円)按円显示（千分位分隔） */
  formatManYen = (c) => {
    if (c == null || c === "") return "";
    const n = Number(c);
    if (Number.isNaN(n)) return c;
    return formatYenNumber(n);
  };

  /** 年度番号 202501 -> 2025年01月 */
  formatYearAndMonth = (v) => {
    if (v == null || v === "") return "";
    const s = String(v).trim();
    if (s.length !== 6) return v;
    return `${s.slice(0, 4)}年${s.slice(4, 6)}月`;
  };

  /** 給料变化整行下绿色横线，単価变化整行下橘红色横线 */
  getRowClassName = (row) => {
    if (!row) return "";
    var classes = [];
    if (row.unitPriceChanged) classes.push("row-line-unitPrice");
    return classes.join(" ");
  };

  getRowStyle = (row) => {
    if (!row || row.intervalColorIndex == null) return {};
    var color = INTERVAL_BG_COLORS[row.intervalColorIndex];
    return color ? { backgroundColor: color } : {};
  };

  render() {
    const {
      employeeFormCode,
      employeeFormCodes,
      employeeName,
      employeeInfo,
      list,
      errorsMessageShow,
      errorsMessageValue,
    } = this.state;

    return (
      <div className="employee-annual-payroll-search">
        <h2 className="mb-4">社員個別年間給料精算</h2>

        <Row className="mb-3">
          <Col sm={3}>
            <InputGroup size="sm" className="mb-3">
              <InputGroup.Prepend>
                <InputGroup.Text>社員区分</InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                as="select"
                name="employeeFormCode"
                value={employeeFormCode}
                onChange={this.valueChange}
                autoComplete="off"
              >
                {(employeeFormCodes || []).map((d) => (
                  <option key={d.code || "empty"} value={d.code}>
                    {d.name || " "}
                  </option>
                ))}
              </Form.Control>
            </InputGroup>
          </Col>
          <Col sm={4}>
            <InputGroup size="sm" className="mb-3">
              <InputGroup.Prepend>
                <InputGroup.Text>社員名</InputGroup.Text>
              </InputGroup.Prepend>
              <Autocomplete
                className="fx1"
                id="employeeName"
                name="employeeName"
                disabled={!employeeFormCode}
                value={
                  (employeeInfo || []).find((v) => v.text === employeeName) ||
                  (employeeInfo || []).find((v) => v.name === employeeName) ||
                  {}
                }
                options={employeeInfo || []}
                getOptionLabel={(option) => option.name || option.text || ""}
                onChange={(event, values) => this.getEmployeeName(event, values)}
                renderInput={(params) => (
                  <div ref={params.InputProps.ref}>
                    <input
                      type="text"
                      {...params.inputProps}
                      className="auto form-control w100p"
                      placeholder={employeeFormCode ? "" : "先に社員形式を選択してください"}
                      readOnly={!employeeFormCode}
                    />
                  </div>
                )}
              />
            </InputGroup>
          </Col>
          <Col sm={2}>
            <Button size="sm" variant="primary" onClick={this.search}>
              <FontAwesomeIcon icon={faSearch} /> 検索
            </Button>{" "}
            <Button size="sm" variant="secondary" onClick={this.reset}>
              リセット
            </Button>
          </Col>
        </Row>

        <Row>
          <Col>
            <Table
              dataSource={list}
              rowKey={(r) => r.rowNo + "-" + (r.yearAndMonth || "")}
              pagination={false}
              bordered
              size="small"
              rowClassName={this.getRowClassName}
              onRow={(record) => ({ style: this.getRowStyle(record) })}
              columns={[
                {
                  title: "番号",
                  dataIndex: "rowNo",
                  key: "rowNo",
                  width: 60,
                  align: "right",
                  onCell: () => ({ style: { whiteSpace: "nowrap" } }),
                  render: (v, record) => {
                    if (record.otherIntervalRowSpan && record.intervalIndex != null) {
                      return record.intervalIndex + "年目 " + record.rowNo;
                    }
                    return record.rowNo;
                  },
                },
                {
                  title: "年度番号",
                  dataIndex: "yearAndMonth",
                  key: "yearAndMonth",
                  width: 120,
                  render: (v) => this.formatYearAndMonth(v),
                },
                { title: "お客様", dataIndex: "customerAbbreviation", key: "customerAbbreviation", width: 120 },
                {
                  title: "単価",
                  dataIndex: "unitPrice",
                  key: "unitPrice",
                  render: (v) => this.formatManYen(v),
                },
                {
                  title: "給料",
                  dataIndex: "salary",
                  key: "salary",
                  render: (v) => this.formatManYen(v),
                },
                {
                  title: "賞与",
                  dataIndex: "bonusAmount",
                  key: "bonusAmount",
                  render: (v) => this.formatYenAbsInt(v),
                },
                {
                  title: "社会保険料",
                  dataIndex: "insuranceFeeAmount",
                  key: "insuranceFeeAmount",
                  render: (v) => this.formatAmount(v),
                },
                {
                  title: "粗利益見込",
                  dataIndex: "roughProfitEst",
                  key: "roughProfitEst",
                  render: (v) => this.formatAmount(v),
                },
                {
                  title: "他のコスト集計",
                  dataIndex: "otherSummary",
                  key: "otherSummary",
                  width: 160,
                  className: "other-cost-summary-cell",
                  render: (cell, record) =>
                    record.otherSummary ? this.formatOtherCostSummary(cell, record) : null,
                  onCell: (record) => ({
                    rowSpan: record.otherIntervalRowSpan,
                    style: record.otherIntervalRowSpan ? { verticalAlign: "middle" } : undefined,
                  }),
                },
              ]}
            />
          </Col>
        </Row>

        {errorsMessageShow && (
          <ErrorsMessageToast
            errorsMessageShow={errorsMessageShow}
            errorsMessageValue={errorsMessageValue}
          />
        )}
      </div>
    );
  }
}

export default EmployeeAnnualPayrollSearch;
